import { serverUrl } from "../runtime";

export default class Urls {
  public static CORE_URL: string = serverUrl("/");
  public static CREATE_LOBBY: string = Urls.CORE_URL + "api/newLobby/";
  public static CHECK_LOBBY_KEY: string = Urls.CORE_URL + "api/checkLobbyKey/";
  public static LEAVE_LOBBY: string = Urls.CORE_URL + "leaveLobby/";
  public static SUBMIT_FEEDBACK: string = Urls.CORE_URL + "api/submitFeedback/";
  public static TEST_AUTH: string = Urls.CORE_URL + "api/testAuth/";
  public static CREATE_DECK: string = Urls.CORE_URL + "api/createDeck";
  public static CREATE_QUESTIONCARD: string = Urls.CORE_URL + "api/createQuestionCard";
  public static CREATE_ANSWERCARD: string = Urls.CORE_URL + "api/createAnswerCard";
  public static DELETE_QUESTIONCARD : string = Urls.CORE_URL + "api/deleteQuestionCard";
  public static DELETE_ANSWERCARD : string = Urls.CORE_URL + "api/deleteAnswerCard";
  public static LOAD_DECK : string = Urls.CORE_URL + "api/loadDeck/";
  public static CHANGE_DECK_NAME : string = Urls.CORE_URL + "api/changeDeckName/";
  public static CHANGE_DECK_DESCRIPTION : string = Urls.CORE_URL + "api/changeDeckDescription/";
  public static CHANGE_DECK_LANGUAGE : string = Urls.CORE_URL + "api/changeDeckLanguage/";
  public static LOAD_OWN_PROFILE : string = Urls.CORE_URL + "api/loadOwnProfile/";
  public static DELETE_DECK : string = Urls.CORE_URL + "api/deleteDeck/";
  public static CHANGE_USER_NAME  : string = Urls.CORE_URL + "api/changeUserName/";
  public static CHANGE_USER_BIO : string = Urls.CORE_URL + "api/changeUserBio";
  public static CHECK_USER_NAME : string = Urls.CORE_URL + "api/checkUserName/";
  public static SEARCH_DECKS : string = Urls.CORE_URL + "api/searchDecks/";
  public static LOAD_DECK_INFOS : string = Urls.CORE_URL + "api/loadDeckInfos/";
  public static GET_RANDOM_DECKS : string = Urls.CORE_URL + "api/getRandomDecks/";
  public static GET_SESSION_LOBBY : string = Urls.CORE_URL + "api/sessionLobby/";
  public static BATCH_IMPORT_CARDS : string = Urls.CORE_URL + "api/batchImportCards";
  public static CREATE_DECK_CONFIG : string = Urls.CORE_URL + "api/deckConfig/create";
  public static GET_DECK_CONFIG : string = Urls.CORE_URL + "api/deckConfig";
  public static GET_DECK_CONFIG_USER : string = Urls.CORE_URL + "api/deckConfig/user";
  public static CATEGORY_COVERAGE : string = Urls.CORE_URL + "api/categoryCoverage";
  public static REPORT_DECK : string = Urls.CORE_URL + "api/reportDeck";
  public static CREATOR_STATS : string = Urls.CORE_URL + "api/creatorStats/";
  public static PROFILE_NAME : string = Urls.CORE_URL + "api/profileName/";
  public static LEADERBOARD : string = Urls.CORE_URL + "api/leaderboard";
  public static CREATOR_PROFILE : string = Urls.CORE_URL + "api/creator/";
  public static FORMAT_QUESTION : string = Urls.CORE_URL + "api/formatQuestion";

  // Shutdown
  public static SHUTDOWN_STATUS : string = Urls.CORE_URL + "api/shutdown-status";
  public static SHUTDOWN_FEEDBACK : string = Urls.CORE_URL + "api/shutdown-feedback";

  // Community
  public static ANNOUNCEMENT : string = Urls.CORE_URL + "api/announcement";
  public static COMMUNITY_STATS : string = Urls.CORE_URL + "api/community/stats";
  public static COMMUNITY_GALLERY : string = Urls.CORE_URL + "api/community/gallery";
  public static COMMUNITY_GALLERY_BANDS : string = Urls.CORE_URL + "api/community/gallery-bands";
  public static COMMUNITY_GALLERY_DRAWINGS : string = Urls.CORE_URL + "api/community/gallery-drawings";
  public static COMMUNITY_TOP_CREATORS : string = Urls.CORE_URL + "api/community/top-creators";
  public static COMMUNITY_ELO_HIGHLIGHTS : string = Urls.CORE_URL + "api/community/elo-highlights";
  public static COMMUNITY_QUESTIONS : string = Urls.CORE_URL + "api/community/questions";
  public static COMMUNITY_ANALYTICS : string = Urls.CORE_URL + "api/community/analytics";
  public static COMMUNITY_PCA : string = Urls.CORE_URL + "api/community/pca";
  public static COMMUNITY_POPULAR_CATEGORIES : string = Urls.CORE_URL + "api/community/popular-categories";
  public static COMMUNITY_ANALYTICS_INSIGHTS : string = Urls.CORE_URL + "api/community/analytics-insights";
  public static COMMUNITY_ANALYTICS_DECKS : string = Urls.CORE_URL + "api/community/analytics-decks";
  public static ADMIN_ANNOUNCEMENTS : string = Urls.CORE_URL + "api/admin/announcements";
  public static ADMIN_INTERMISSIONS : string = Urls.CORE_URL + "api/admin/intermissions";
  public static ADMIN_PICASSO_LABELER : string = Urls.CORE_URL + "api/admin/picasso-labeler";
  public static CTA_CARDS : string = Urls.CORE_URL + "api/cta-cards";
  public static ADMIN_CTA_CARDS : string = Urls.CORE_URL + "api/admin/cta-cards";

  // Social Links
  public static SOCIAL_LINKS : string = Urls.CORE_URL + "api/social-links";
  public static ADMIN_SOCIAL_LINKS : string = Urls.CORE_URL + "api/admin/social-links";

  // Topics
  public static GET_TOPICS : string = Urls.CORE_URL + "api/topics";
  public static DECKS_BY_TOPICS : string = Urls.CORE_URL + "api/decks/byTopics";
  public static SET_DECK_PRIVACY : string = Urls.CORE_URL + "api/setDeckPrivacy";

}
